import React from 'react';
import { t } from '@lingui/core/macro';
import { ReadOnlyList, SectionCard } from 'src/components/forms';
import { OrgUnitTypeRecord, typeBehaviour } from 'src/util/orgUnitTypes';
import { OrgUnitRecord, formatAncestorPath } from './orgUnitModel';

export type InstitutionSummarySectionProps = { draft: OrgUnitRecord; type: OrgUnitTypeRecord | null };

/** Everything but the contacts, read-only, for the contact-info and read-only modes. */
export function InstitutionSummarySection({ draft, type }: InstitutionSummarySectionProps) {
  const path = formatAncestorPath(draft.ancestors);

  if (!typeBehaviour(type?.name).isInstitution) {
    return (
      <SectionCard span={12} title={t`Details`} hint={t`Only an administrator can change these.`}>
        <ReadOnlyList
          items={[
            { label: t`Name`, value: draft.name },
            { label: t`Organizational Unit Type`, value: type?.name },
            { label: t`Parent Organizational Unit`, value: path },
            { label: t`Business Code`, value: draft.code },
          ]}
        />
      </SectionCard>
    );
  }

  const address = [draft.address1, draft.address2, draft.city, [draft.state, draft.postalCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');

  return (
    <SectionCard span={12} title={t`Institution details`} hint={t`Only an administrator can change these.`}>
      <ReadOnlyList
        items={[
          { label: t`Classification`, value: path },
          { label: t`Institution ID`, value: draft.entityIdentifier },
          { label: t`License Number`, value: draft.licenceNumber },
          { label: t`Parent Entity`, value: draft.parentEntity },
          { label: t`System Code (CFIID)`, value: draft.code ? <code>{draft.code}</code> : null },
          { label: t`Address`, value: address },
        ]}
      />
    </SectionCard>
  );
}

export default InstitutionSummarySection;
